var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack628({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.83,11.78V3.91H8.18A5.75,5.75,0,0,1,10,4.12a1.75,1.75,0,0,1,.92.76,2.24,2.24,0,0,1,.34,1.24,2.09,2.09,0,0,1-.52,1.46,2.49,2.49,0,0,1-1.55.73,3.91,3.91,0,0,1,.85.66,9,9,0,0,1,.9,1.28l1,1.53H10L8.86,10.07A11.89,11.89,0,0,0,8,8.91a1.27,1.27,0,0,0-.47-.33,2.68,2.68,0,0,0-.8-.08H6.42v3.28ZM6.42,7.24H7.6A5.73,5.73,0,0,0,9,7.14a.78.78,0,0,0,.44-.33,1,1,0,0,0,.17-.59.94.94,0,0,0-.22-.64.92.92,0,0,0-.6-.31c-.12,0-.51,0-1.16,0H6.42Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack628);
export default __webpack_public_path__ + "static/media/Symbolpack_6_28.480b115dfb893b015479c30bb41d3dde.svg";
export { ForwardRef as ReactComponent };